import { api } from './client';

/** Sala de Máquinas (ADMIN): estado en vivo del sistema. GET /api/system/status */

export interface CanalStatus {
  id: string;
  nombre: string;
  tipo: string;
  estado: string;
  ultimoError: string | null;
  warmup: { dia: number; totalDias: number; topeDiario: number; enviadosHoy: number } | null;
  ultimoEntranteAt: string | null;
  ultimoSalienteAt: string | null;
  /**
   * ⚠️ Cuánto tiene este canal. ADR-008 dice que la frontera es el DESPLIEGUE:
   * todo lo que está en esta base es de este cliente. Mostrar el volumen es lo
   * que permite darse cuenta de que hay un canal que no corresponde -- por el
   * nombre solo, uno ajeno con 249 conversaciones y uno vacío se ven igual.
   */
  conversaciones: number;
  contactos: number;
}

export interface AgenteStatus {
  id: string;
  nombre: string;
  estado: string;
  motor: string;
  enHorario: boolean;
  turnosHoy: number;
  ultimoTurnoAt: string | null;
  promedioRespuestaMs: number | null;
}

export interface WorkerStatus {
  nombre: string;
  intervalMs: number;
  startedAt: string;
  lastRunAt: string | null;
  nextDueAt: string;
  vencido: boolean;
  ultimoError: string | null;
}

export interface SystemStatus {
  generatedAt: string;
  horario: {
    responder_desde: number;
    responder_hasta: number;
    horario_activo: boolean;
    timezone: string;
  };
  canales: CanalStatus[];
  agentes: AgenteStatus[];
  workers: WorkerStatus[];
  vps: {
    configurado: boolean;
    ping: {
      ok: boolean;
      latencyMs: number | null;
      reporte: unknown;
      checkedAt: string;
      error: string | null;
    } | null;
  };
  correo: { configurado: boolean; ultimoEnvio: { at: string; ok: boolean } | null };
  voz: {
    configurado: boolean;
    proveedor: 'groq' | 'http' | null;
    ultimaTranscripcion: { at: string; ok: boolean } | null;
  };
  /** Señales del guardián (F4b): backup, disco y errores del sistema. */
  salud: {
    backup: {
      estado: 'ok' | 'atrasado' | 'incompleto' | 'ilegible';
      ultimaCorridaAt: string | null;
    };
    discoPct: number | null;
    errores24h: number;
    ultimosErrores: Array<{ level: string; message: string; createdAt: string }>;
    /** Rediseño /sistema: una fila por mensaje con contador (24h). */
    erroresAgrupados: Array<{
      message: string;
      level: string;
      count: number;
      ultimaAt: string | null;
    }>;
  };
}

export const getSystemStatus = () => api.get<SystemStatus>('/api/system/status');
